import InfiniteScroll from 'react-infinite-scroll-component';
import { Role } from 'auth';
import { useRegisterTypeStrings } from '@/modules/common/hooks/useRegisterTypeStrings.tsx';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import IssuerDividendItem from '@/modules/issuer-dashboard/components/items/IssuerDividendItem.tsx';
import { DistributionsHeaderAction } from '@/modules/issuer-dashboard/pages/IssuerDistributionsEvents.tsx';
import { useIssuerDividendEventInfiniteListQuery } from '@/modules/issuer-dashboard/queries/dividends.tsx';
import { EmptyListState, PageLayout, Spinner } from 'ui';

const IssuerDividends = () => {
  const getRegisterTypeStrings = useRegisterTypeStrings();

  const {
    data: dividendEventList,
    isLoading: isDividendEventListLoading,
    fetchNextPage: fetchDividendEventListNextPage,
    hasNextPage: dividendEventListHasNextPage,
  } = useIssuerDividendEventInfiniteListQuery({ page: 1, page_size: 15 }, {});

  return (
    <PageLayout
      title={getRegisterTypeStrings('dividend', { capitalize: true, plural: true })}
      headerAction={<DistributionsHeaderAction />}
    >
      <EmptyListState
        title={`No ${getRegisterTypeStrings('dividend')} events created yet`}
        description={`Click on Add new ${getRegisterTypeStrings(
          'dividend',
        )} button to create a ${getRegisterTypeStrings('dividend')} event`}
        isLoading={isDividendEventListLoading}
        isSearchUsed={false}
        itemsCount={dividendEventList?.pages.flatMap(({ data }) => data).length ?? 0}
      />
      {isDividendEventListLoading && (
        <div className="w-full h-full flex items-center justify-center">
          <Spinner size="lg" />
        </div>
      )}
      <InfiniteScroll
        next={fetchDividendEventListNextPage}
        dataLength={dividendEventList?.pages.length ?? 0}
        hasMore={dividendEventListHasNextPage || false}
        style={{ overflow: 'unset' }}
        loader={
          <div className="flex justify-center items-center h-16 w-full">
            <Spinner size="md" variant="primary" />
          </div>
        }
        scrollableTarget="scrollable"
      >
        <div className="w-full flex flex-col space-y-2">
          {dividendEventList?.pages.map(({ data }) =>
            data.map((dividend, i) => (
              <IssuerDividendItem key={'dividend_' + dividend.id} dividend={dividend} index={i} />
            )),
          )}
        </div>
      </InfiniteScroll>
    </PageLayout>
  );
};

export default withPrivateAccess(IssuerDividends, [Role.SR_ISSUER, Role.SR_ISSUER_ADMIN]);
